import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable()
export class ZorroDateInterceptor implements HttpInterceptor {
    private readonly dateTimeRegex = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2}(?:\.\d*)?Z?)$/;
    private readonly dateRegex = /^(\d{4})-(\d{2})-(\d{2})/;

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(req)
            .pipe(
                map((event: HttpEvent<any>) => {
                    if (event instanceof HttpResponse) {
                        this.convertDates(event.body);
                    }
                    return event;
                }));
    }

    private convertDates(object: object) {
        if (!object || !(object instanceof Object)) {
            return;
        }

        if (object instanceof Array) {
            for (const item of object) {
                this.convertDates(item);
            }
        }

        for (const key of Object.keys(object)) {
            this.convertObject(object, key);
        }
    }

    private convertObject(object: object, key: string) {
        const value = object[key];
        if (value instanceof Array) {
            for (const item of value) {
                this.convertDates(item);
            }
        }
        if (value instanceof Object) {
            this.convertDates(value);
        }
        if (typeof value === 'string' && this.dateTimeRegex.test(value)) {
            if (value.charAt(value.length - 1) === 'Z') {
                object[key] = new Date(value);
            } else {
                object[key] = new Date(`${value}Z`);
            }
        }
    }
}
